import {
  // averageAggregatorFn,
  customFrequencyFn,
  defaultFn,
  weightedAverageAggregatorFn,
} from './chartAggregator';

const { CHART_AGGREGATORS, AGGREGATORS } = require('src/constants/chart');

class ChartAggregatorHandler {
  constructor() {
    const handlers = {
      [CHART_AGGREGATORS.WEIGHTED_AVERAGE]: weightedAverageAggregatorFn,
      // [CHART_AGGREGATORS.AVERAGE]: averageAggregatorFn,
      [CHART_AGGREGATORS.CUSTOM_FREQUENCY]: customFrequencyFn,
    };

    Object.values(AGGREGATORS).forEach((key) => {
      if (!handlers[key]) {
        handlers[key] = defaultFn;
      }
    });

    this.handlers = handlers;
  }

  handle(key, series, dataSeries) {
    this.handlers[key](series, dataSeries, {});
  }
}

export default ChartAggregatorHandler;
